import React, { useCallback, useState } from "react";
import TranslatedText from "./TranslatedText";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import "../Styles/Carousel.css";
import { Typography, Button, Stack } from "@mui/material";

const cardItems = [
  {
    id: 1,
    title: (
      <h2 className="h2-carousel">
        <TranslatedText defaultText="Зоопарк подарував нам чудове відчуття, що ми вдома" />
      </h2>
    ),
    copy: (
      <a
        href="https://www.op.no/48-ukrainske-flyktninger-dyreparken-ga-oss-en-deilig-folelse-av-a-vare-hjemme/s/5-36-1261688"
        underline="hover"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          className="carousel-btn"
          size="large"
          sx={{
            color: "white",
            fontSize: 25,
            "@media screen and (max-width: 1024px)": {
              fontSize: "22px",
              marginTop: "48vh",
              color: "#e8e2b0",
            },

            "@media screen and (max-width: 690px)": {
              fontSize: "10px",
              marginTop: "44vh",
              color: "#e8e2b0",
            },
          }}
          gutterBottom
        >
          {" "}
          <OpenInNewOutlinedIcon
            sx={{
              "@media screen and (max-width: 1024px)": {
                display: "none",
              },
            }}
          />
          <TranslatedText defaultText="Натисніть тут, щоб дізнатися більше про подію" />
        </Button>
      </a>
    ),
  },
  {
    id: 2,
    title: (
      <h2 className="h2-carousel">
        <TranslatedText defaultText="Сьогодні їх запросили до парламенту" />
      </h2>
    ),
    copy: (
      <a
        href="https://www.nrk.no/vestfoldogtelemark/zelenskyjs-tale-til-stortinget_-_-vi-fikk-tarer-i-oynene-1.15913899"
        underline="hover"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          size="large"
          sx={{
            color: "white",
            fontSize: 25,
            "@media screen and (max-width: 1024px)": {
              fontSize: "16px",
              marginTop: "50vh",
              color: "#e8e2b0",
            },

            "@media screen and (max-width: 690px)": {
              fontSize: "10px",
              marginTop: "42vh",
              color: "#e8e2b0",
            },
          }}
          gutterBottom
        >
          <OpenInNewOutlinedIcon
            sx={{
              "@media screen and (max-width: 1024px)": {
                display: "none",
              },
            }}
          />
          <TranslatedText defaultText="Натисніть тут, щоб дізнатися більше про подію" />
        </Button>
      </a>
    ),
  },
  {
    id: 3,
    title: (
      <h2 className="h2-carousel">
        <TranslatedText defaultText="Українці разом стоять на площі" />
      </h2>
    ),
    copy: (
      <a
        href="https://www.larvik.kommune.no/kultur-idrett-og-frivillighet/aktuelt/maria-35-talte-paa-torget-leiligheten-vaar-er-bombet-to-ganger/"
        underline="hover"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          size="medium"
          sx={{
            color: "white",
            fontSize: 25,

            "@media screen and (max-width: 1024px)": {
              fontSize: "16px",
              marginTop: "54vh",
              color: "#e8e2b0",
            },

            "@media screen and (max-width: 690px)": {
              fontSize: "10px",
              marginTop: "49vh",
              color: "#e8e2b0",
            },
          }}
          gutterBottom
        >
          {" "}
          <OpenInNewOutlinedIcon
            sx={{
              "@media screen and (max-width: 1024px)": {
                display: "none",
              },
            }}
          />
          <TranslatedText defaultText="Натисніть тут, щоб дізнатися більше про подію" />
        </Button>
      </a>
    ),
  },
];

const CardCarousel = () => {
  const [indexes, setIndexes] = useState({
    previousIndex: 0,
    currentIndex: 0,
    nextIndex: 1,
  });

  function determineClasses(indexes, cardIndex) {
    if (indexes.currentIndex === cardIndex) {
      return "active";
    } else if (indexes.nextIndex === cardIndex) {
      return "next";
    } else if (indexes.previousIndex === cardIndex) {
      return "prev";
    }
    return "inactive";
  }

  const handleCardTransition = useCallback(() => {
    if (indexes.currentIndex >= cardItems.length - 1) {
      setIndexes({
        previousIndex: cardItems.length - 1,
        currentIndex: 0,
        nextIndex: 1,
      });
    } else {
      setIndexes((prevState) => ({
        previousIndex: prevState.currentIndex,
        currentIndex: prevState.currentIndex + 1,
        nextIndex:
          prevState.currentIndex + 2 === cardItems.length
            ? 0
            : prevState.currentIndex + 2,
      }));
    }
  }, [indexes.currentIndex]);

  return (
    <div>
      <Typography
        variant="h2"
        sx={{
          fontSize: 40,
          textAlign: "center",
          "@media screen and (max-width: 768px)": { fontSize: "32px" },
        }}
        gutterBottom
      >
        <TranslatedText defaultText="Перші кроки до інтеграції" />
      </Typography>

      <ul className="card-carousel">
        {cardItems.map((card, index) => (
          <li
            key={card.id}
            className={`card ${determineClasses(indexes, index)}`}
          >
            <h2>{card.title}</h2>
            <p>{card.copy}</p>
            <Stack spacing={2} direction="row">
              <Button
                className="carousel-btn"
                variant="contained"
                sx={{
                  borderRadius: "25px",
                  marfinButton: "100px",
                  "@media screen and (max-width: 690px)": {
                    fontSize: "10px",
                    marginLeft: "3vw",
                  },
                }}
                onClick={handleCardTransition}
              >
                <TranslatedText defaultText="Перейдіть до наступного" />
              </Button>
            </Stack>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CardCarousel;
